import React from 'react'
import { Text, View, StyleSheet } from "@react-pdf/renderer"

const TableHeader: React.FC = () => {

    const styles = StyleSheet.create({
        row: {
            flexDirection: "row",
            alignItems: "stretch",
            width: "100%",
        },  
        column: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '4px 2px',
            border: "1px solid black",
            borderRight: '0',
            fontSize: '8px',
            fontWeight: 'bold',
            fontfamily: 'Arial',
            textAlign: 'center',
        }
    })

    const Column: React.FC <{text: string, width: string, last?: boolean}> = ({text, width, last}) => (
        <View style = {[styles.column, {width, borderRight: !!last ? '1px solid black' : 0}]}>
            <Text>{text}</Text>
        </View>
    )

    return(

        <View style = {styles.row}>
            <Column text = "#" width = "3%" />
            <Column text = "Cliente" width = "40%" />
            <Column text = "DBO Anterior" width = "10%" />
            <Column text = "DBO Atual" width = "10%" />
            <Column text = "Diferença" width = "10%" />
            <Column text = "Coletas" width = "10%" />
            <Column text = "Desenquadramento" width = "15%" last />
        </View>

    )

}

export default TableHeader